import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchPaymentMethods(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/payment-methods')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}
